module.exports = __webpack_public_path__ + "static/22-fe6a7cedd7ad8ede8f0504679b946753.png";